module.exports = __webpack_public_path__ + "img/Щелкающий палец.16e0be07.png";